import { ButtonBase, CustomBtnProps } from "./ButtonBase";

function ContainedButton({
  title,
  height,
  width,
  iconPosition,
  btnIconSrc,
  onClick,
  loading,
}: CustomBtnProps) {
  return (
    <ButtonBase
      title={title}
      sx={styles.containedBtn}
      height={height}
      width={width}
      variant="contained"
      btnIconSrc={btnIconSrc}
      onClick={onClick}
      iconPosition={iconPosition}
      loading={loading}
    />
  );
}

function TextButton({
  title,
  height,
  width,
  iconPosition,
  btnIconSrc,
  onClick,
  loading,
  iconAnchorLoading
}: CustomBtnProps) {
  return (
    <ButtonBase
      title={title}
      sx={styles.containedBtn}
      height={height}
      width={width}
      variant="text"
      btnIconSrc={btnIconSrc}
      onClick={onClick}
      iconPosition={iconPosition}
      loading={loading}
      iconAnchorLoading={iconAnchorLoading}
    />
  );
}

function OutlinedButton({
  title,
  height,
  width,
  iconPosition,
  btnIconSrc,
  onClick,
  loading,
  iconAnchorLoading,
}: CustomBtnProps) {
  return (
  
      <ButtonBase
        title={title}
        sx={styles.containedBtn}
        height={height}
        width={width}
        variant="outlined"
        btnIconSrc={btnIconSrc}
        onClick={onClick}
        iconPosition={iconPosition}
        loading={loading}
        iconAnchorLoading={iconAnchorLoading}
      />
  );
}

const styles = {
  outlinedBtn: {},

  containedBtn: {},

  secondaryBtn: {},
};

export { ContainedButton, TextButton, OutlinedButton };
